import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { t } from '@kadice/shared';
import { App } from './App';
import { loadText } from './text';
import './styles.css';

const root = createRoot(document.getElementById('root')!);

// Every word on screen comes from the server's text file, so it loads before anything renders.
void loadText().then((loaded) => {
  if (!loaded) {
    // The one message that can't come from the text file: the server that serves it is unreachable.
    root.render(<p className="center">Could not reach the server.</p>);
    return;
  }
  document.title = t('app.title');
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
